export default "__VITE_ASSET__lKNBi9VE__"